import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import emailValidate from '@vr/devkit/validators/emailValidate';
import { useDispatch, useSelector } from 'react-redux';
import { Button, TextField } from '../../elements';
import { ContainerButton, Title, Description, Actions } from './common';
import getErrorMsg from '../../helpers/errorMessages';
import { ReCaptcha } from '~/components';
import { setSuccessKey } from '~/store/modules/recaptcha/actions';

const ContainerActions = styled.div`
  margin-top: 23px;
`;
const ContainerReCaptcha = styled.div`
  display: flex;
  justify-content: center;
  margin: 10px 0;
`;

export default function ForgotPasswordForm({ onSubmit }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const [resetRecaptcha, setResetRecaptcha] = useState(false);
  const { siteKey, successKey } = useSelector(state => state.recaptcha);
  const { handleSubmit, errors, formState, ...formControl } = useForm({
    mode: 'onChange',
  });

  useEffect(() => {
    if (successKey === '') {
      setResetRecaptcha(true);
    }
  }, [successKey]);

  function handleSuccessKey(key) {
    setResetRecaptcha(false);
    dispatch(setSuccessKey(key));
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} noValidate>
      <Title color="white">Esqueci minha senha</Title>
      <Description fontSize="15" color="white">
        Informe seu endereço de e-mail
      </Description>
      <TextField
        ariaLabel="Email"
        fullWidth
        label="Seu e-mail cadastrado *"
        name="email"
        type="email"
        rules={{
          required: true,
          validate: val => {
            return emailValidate(val);
          },
        }}
        formControl={formControl}
        error={!!errors.email}
        caption={getErrorMsg(errors, 'email')}
      />
      {siteKey && (
        <ContainerReCaptcha>
          <ReCaptcha
            data-testid="captcha"
            sitekey={siteKey}
            onChange={handleSuccessKey}
            resetRecaptcha={resetRecaptcha}
          />
        </ContainerReCaptcha>
      )}
      <ContainerActions>
        <Actions>
          <Button
            ariaLabel="Solicitar nova senha"
            label="Solicitar nova senha"
            type="submit"
            variant="contained"
            disabled={!formState.isValid || !successKey}
          />
          <ContainerButton>
            <Button
              label="Cancelar"
              onClick={() => history.push('/login')}
              variant="transparent"
            />
          </ContainerButton>
        </Actions>
      </ContainerActions>
    </form>
  );
}

ForgotPasswordForm.propTypes = {
  onSubmit: PropTypes.func,
};
